import React, { useEffect, useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Typography,
  Container,
} from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

// Contexts
import LayoutContext from "../../context/layout/LayoutContext";
import AuthContext from "../../context/auth/AuthContext";

// Components
import Footer from "../layout/Footer";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.light,
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const ForgetPassword = () => {
  const classes = useStyles();
  const history = useHistory();

  const { setAlert } = useContext(LayoutContext);
  const { forgetPassword, reset_message, error, clearErrors } =
    useContext(AuthContext);

  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState("");

  const onChange = (e) => setEmail(e.target.value);

  const onSubmit = (e) => {
    e.preventDefault();

    if (email === "") {
      setAlert("Please enter the field.", "error");
    } else {
      setSubmitted(true);
      forgetPassword(email);
    }
  };

  useEffect(() => {
    if (reset_message) {
      setSubmitted(false);
      setAlert(reset_message, "success");
    }
  }, [reset_message]);

  useEffect(() => {
    if (error === "User not found." || error === "Email failed to send.") {
      setSubmitted(false);
      setAlert(error, "error");
      clearErrors();
    }
  }, [error]);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />

      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Forget Password{" "}
        </Typography>
        <form className={classes.form} noValidate onSubmit={onSubmit}>
          <Typography variant="body2" align="center" gutterBottom>
            Lost your password ? Please enter your email address.You will
            receive a link to create a new password via email.{" "}
          </Typography>
          <br />
          <TextField
            required
            fullWidth
            variant="outlined"
            margin="normal"
            id="email"
            name="email"
            label="Email"
            autoFocus
            value={email}
            onChange={onChange}
          />
          <Button
            fullWidth
            size="large"
            variant="contained"
            color="primary"
            type="submit"
            disabled={submitted}
            className={classes.submit}
          >
            Reset Password{" "}
          </Button>
          <Grid container justifyContent="flex-end">
            <Grid item>
              {" "}
              {/* <Link href="/login" variant="body2"> */}{" "}
              <Link variant="body2" onClick={() => history.push("/login")}>
                Remember your password ?
              </Link>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </form>{" "}
      </div>

      <Footer />
    </Container>
  );
};

export default ForgetPassword;
